import _ from 'lodash'

export default {
    install(Vue) {
        Vue.filter('get', (val, path) => {
            return _.get(val, path)
        })
    }
}
